import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../../modules/lxs-create-order/lxs-create-order.data';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';

/**
 * GetAllProducts Input Action
 */
export class GetAllProductsInput implements Msdyn365.IActionInput {
    public soldTo: string;
    public shipTo: string;
    constructor(soldTo: string, shipTo: string) {
        this.soldTo = soldTo;
        this.shipTo = shipTo;
    }

    public getCacheKey = () => `GetAllProducts-${this.soldTo}-${this.shipTo}`;
    public getCacheObjectType = () => 'GetAllProducts';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetAllProducts {
    '@odata.context'?: string;
    EndCustomers: boolean;
    RecordCreatedDate?: Date;
    Products: IGetAllProductsResult[];
    error?: ErrorCode;
}
export interface IGetAllProductsResult {
    ProductNumber: string;
    SalesOrg: string;
    SalesOrgText: string;
    SalesUnit: string;
    DistributionChannel: string;
    DistributionChannelText: string;
    Division: string;
    BaseUnit: string;
    Incoterm1: string;
    Incoterm2: string;
    DivisionText: string;
    ProductName: string;
    UnitOfMeasure: string;
    EndCustomers: IEndCustomer[];
    RecordCreatedDate: Date;
    ExtensionProperties: ExtensionProperties[];
    PackagingQty: string;
    PackagingQtyUnit: string;
    MinimumQty: string;
    MinimumQtyUnit: string;
    AlternativeUnits: IAlternativeUnits[];
    CustomerProductName: string;
    CustomerProductNumber: string;
    IncotermLocation: string;
    Hierarchy1Name: string;
    Hierarchy2Name: string;
    Hierarchy3Name: string;
}

export interface IAlternativeUnits {
    Unit: string;
    Numerator: string;
    Denomerator: string;
    UnitText: string;
}

export interface IEndCustomer {
    EndCustomerNumber: string;
    EndCustomerDisplayName: string;
    MinimumQty: string;
    MinimumQtyUnit: string;
    MinimumQtyOnOrderLevel: boolean;
}

export interface ExtensionProperties {
    Key: string;
    Value: { StringValue: string };
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetAllProductsInput('', '');
};

async function action(input: GetAllProductsInput, ctx: Msdyn365.IActionContext): Promise<IGetAllProducts> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetAllProducts>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetAllProducts(language='${ctx.requestContext.locale}',soldTo='${input.soldTo}',shipTo='${input.shipTo}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    } else {
        return {
            Products: [],
            EndCustomers: false,
            error: { errorCode: response.status, errorText: response.statusText }
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAllProducts>>((input, ctx) => trackedAction(action, input, ctx, 'GetAllProducts')),
    id: 'GetAllProducts',
    input: createInput
});
